import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useOnClickOutside } from 'usehooks-ts';
import MoreIcon from '@/assets/images/icons/more.svg?react';
import useMarkAllSessionRead from '@/hooks/conversations/use-mark-all-session-read';
import { makePrompt } from '@/stores/prompter';
import cn from '@/utils/merge-class-names';

interface Props {
  className?: string;
}

export default function SessionHeaderMenu({ className }: Props) {
  const { t } = useTranslation();
  const detailRef = useRef<HTMLDetailsElement>(null);
  const { mutate } = useMarkAllSessionRead();

  useOnClickOutside(detailRef, () => detailRef.current?.removeAttribute('open'));

  const handleReadAll = () => {
    detailRef.current?.removeAttribute('open');
    return makePrompt({
      key: 'session-read-all',
      type: 'dialog',
      title: t('conversation.read-all.confirm-message'),
      promise: () => mutate(),
    });
  };

  return (
    <details
      key='session-header-menu'
      className={cn('dropdown dropdown-end', className)}
      ref={detailRef}>
      <summary
        tabIndex={0}
        role='button'
        className='btn btn-square btn-ghost mode-embedded:btn-sm mode-embedded:text-primary-content layout-mini:text-inherit layout-compact:text-inherit'>
        <MoreIcon className='size-4 rotate-90' />
      </summary>

      <ul className='menu dropdown-content z-50 w-32 rounded-lg bg-neutral-0 shadow-lg'>
        <li className='w-full'>
          <button
            type='button'
            className='flex w-full flex-center gap-2'
            onClick={handleReadAll}>
            {t('conversation.read-all.label')}
          </button>
        </li>
      </ul>
    </details>
  );
}
